import { atom } from "jotai";

export const openedDidomiModalState = atom<boolean>(false);
